
<header class="topbar">
	<div class="brand-mark" aria-hidden="true">BMW</div>

	<span class="brand-name">{{'tl_mra_concession_portal' | t}}</span>
	<span class="brand-country">{{'tl_france' | t}}</span>

	<div class="language-switch" role="group" [attr.aria-label]="'lbl_language' | t">
		<button type="button" class="language-option" lang="fr" aria-label="Français"
			[class.active]="language() === 'fr'" [attr.aria-pressed]="language() === 'fr'"
			(click)="selectLanguage('fr')">FR</button>
		<button type="button" class="language-option" lang="en" aria-label="English"
			[class.active]="language() === 'en'" [attr.aria-pressed]="language() === 'en'"
			(click)="selectLanguage('en')">EN</button>
		
	</div>

	<div class="user-area" *ngIf="userName as auth">
		<span class="user-name">{{ userName }}</span>
		<span class="user-role">{{ role === 'dealer' ? ('lbl_dealer' | t) : ('lbl_nsc' | t) }}</span>
		<button class="logout-button" type="button" (click)="logout()">
			<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"/><path d="M9 12h12l-3 -3m0 6l3 -3"/></svg>
			<span>{{'lbl_log_out' | t}}</span>
		</button>
	</div>
</header>
